<template>
    <section class="pt-4 pt-md-8 pb-4 pb-md-8">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div v-if="messageSent">
                        <h2>Message Sent</h2>
                        <p>Thank you for your interest. Your messaage has been sent, you will receive a reply within the next business day.</p>
                    </div>

                    <form v-if="!messageSent" novalidate @submit.prevent="onSave">
                        <fieldset>
                            <legend>Contact us for more information.</legend>

                            <div class="form-group">
                                <label for="name">Name</label>
                                <input v-model="name" class="form-control" placeholder="Enter your name" />
                                <div v-if="v$.name.$error" class="small text-danger">Name is required</div>
                            </div>

                            <div class="form-group">
                                <label for="email">Email</label>
                                <input v-model="email" class="form-control" placeholder="Enter your email" type="email" />
                                <div v-if="v$.email.$error" class="small text-danger">Email is required</div>
                            </div>

                            <div class="form-group">
                                <label for="message">Message</label>
                                <textarea v-model="message" class="form-control" placeholder="Enter your message"></textarea>
                                <div v-if="v$.message.$error" class="small text-danger">Message is required</div>
                            </div>

                            <button class="btn btn-primary" type="submit">Send</button>
                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios';
    import { useVuelidate } from '@vuelidate/core';
    import { required, email } from '@vuelidate/validators';

    export default {
        name: 'ContactForm',
        setup: () => ({ v$: useVuelidate() }),
        data: () => ({
            name: '',
            email: null,
            message: null,
            messageSent: false
        }),
        methods: {
            async onSave() { 
                const isValid = await this.v$.$validate();

                if (!isValid) {
                    return;
                }

                // only want to save key information
                const d = {
                    message: `Contact form submission. Name: ${this.name}; Email: ${this.email}; Message: ${this.message}`
                };

                axios.post('/api/modules/communications/email/send', d)
                    .then(this.messageSent = true);
            }
        },
        validations: () => ({
            name: { required },
            email: { required, email }, 
            message: { required }
        })
    }
</script>